import { useFlavor } from "../../flavors";
import { TransferPage as TransferPageA } from "./flavor-a/TransferPage";
import { TransferPage as TransferPageB } from "./flavor-b/TransferPage";
import { TransferPage as TransferPageC } from "./flavor-c/TransferPage";

export const TransferPageRouter = () => {
  const { isFlavor } = useFlavor();
  
  if (isFlavor('B')) return <TransferPageB />;
  if (isFlavor('C')) return <TransferPageC />;
  return <TransferPageA />;
};
